'use client';

import { c as _c } from "react/compiler-runtime";
import IconUser from '@/components/assets/icon_user.svg';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Skeleton } from '@/components/ui/skeleton';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { Link } from '@/i18n/navigation';
export default function WorldAvatar() {
  const $ = _c(11);
  const {
    roomData
  } = useCheckEnterRoomContext();
  const t0 = `/profile/${roomData.owner.community_user_id}`;
  let t1;
  if ($[0] !== roomData.owner.display_name || $[1] !== roomData.owner.head_icon_url) {
    t1 = <AvatarImage src={roomData.owner.head_icon_url} alt={roomData.owner.display_name} className="object-cover" />;
    $[0] = roomData.owner.display_name;
    $[1] = roomData.owner.head_icon_url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== roomData.owner.head_icon_url) {
    t2 = <AvatarFallback>{!roomData.owner.head_icon_url ? <IconUser className="bg-vive-primary-40 size-full" /> : <Skeleton className="bg-vive-primary-40 size-full" />}</AvatarFallback>;
    $[3] = roomData.owner.head_icon_url;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <Avatar className="bg-vive-primary-40 size-12 transition-all">{t1}{t2}</Avatar>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t3) {
    t4 = <Link href={t0} className="relative w-fit" target="_blank">{t3}</Link>;
    $[8] = t0;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}